import React from 'react';
interface SectionHeadlineProps {
  lead: string;
  follow: string;
  size?: 'large' | 'medium';
}

/** Two-line confident headline: the statement, then the turn in Ferring blue. */
export function SectionHeadline({
  lead,
  follow,
  size = 'large'
}: SectionHeadlineProps) {
  return <h2 className={['font-extrabold leading-[0.95] tracking-[-0.045em] text-[var(--fg)]', size === 'large' ? 'text-[42px] sm:text-[58px] xl:text-[70px]' : 'text-[36px] sm:text-[48px] xl:text-[58px]'].join(' ')} data-id="element-307" data-mp="mu1m57bg4que">
      {lead}
      <span className="block text-[var(--brand)]" data-id="element-308" data-mp="dvg8nqku020h">{follow}</span>
    </h2>;
}